import { render, staticRenderFns } from "./ClientMaintain.vue?vue&type=template&id=0a968e60&"
import script from "./ClientMaintain.vue?vue&type=script&lang=js&"
export * from "./ClientMaintain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a968e60')) {
      api.createRecord('0a968e60', component.options)
    } else {
      api.reload('0a968e60', component.options)
    }
    module.hot.accept("./ClientMaintain.vue?vue&type=template&id=0a968e60&", function () {
      api.rerender('0a968e60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/clients/ClientMaintain.vue"
export default component.exports